export const isEmpty = (value) => {
  return value === undefined || value === null || value === "";
};

export const checkNumberLimit = (value) => {
  const regex = /^[0-9]{0,10}$/;
  if (regex.test(value)) {
    return true;
  } else {
    return false;
  }
};

export function downloadBase64File(base64Data, fileName) {
  // Create a virtual link element
  const link = document.createElement("a");
  link.href = base64Data;
  link.download = fileName;

  // Trigger a click event on the link element
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const parseErrorMessage = (errorMessage) => {
  const start = errorMessage.indexOf("[");
  const end = errorMessage.lastIndexOf("]");
  if (start !== -1 && end !== -1) {
    const errorsString = errorMessage.substring(start + 1, end);
    const errorsArray = errorsString
      .split(", Error on Data ")
      .map((error, index) => {
        return index === 0 ? error : "Error on Data " + error;
      });
    return errorsArray.join("\n ");
  }
  return errorMessage;
};
